import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Segmented as AntdSegmented } from "antd";
import "./Segmented.scss";
/**
 * Switch between options, not wrapped with a tooltip or label like Input.Segmented
 */
const Segmented = forwardRef((props, ref) => {
    return (_jsx(AntdSegmented, Object.assign({}, props, { className: `te-segmented ${props.className || ""}`, ref: ref })));
});
export default Segmented;
